import { absolutePathWithArrayIndices } from "../absolutePath";
import type { MediaAnalyticsApiParams } from "./types";

export const media = {
  overview: {
    views: (params: MediaAnalyticsApiParams) =>
      absolutePathWithArrayIndices("analytics/media/overview/views", params),
    unique_viewers: (params: MediaAnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/media/overview/unique_viewers",
        params,
      ),
    average_progress: (params: MediaAnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/media/overview/average_progress",
        params,
      ),
    average_duration: (params: MediaAnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/media/overview/average_duration",
        params,
      ),
    total_duration: (params: MediaAnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/media/overview/total_duration",
        params,
      ),
  },
  timeline: {
    viewers_timeline: (params: MediaAnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/media/timeline/viewers_timeline",
        params,
      ),
    average_progress_timeline: (params: MediaAnalyticsApiParams) =>
      absolutePathWithArrayIndices(
        "analytics/media/timeline/average_progress_timeline",
        params,
      ),
  },
};
